<template>
    <div class="studentDetail app-inner">
          <div class="public-btn-small flex align-cen posta" style="padding-left:0;left:210px;width:calc(100% - 210px)">
            <div class="public-btn-small-plan"   style="margin-left:0" @click="$util.reback('/teacheManage/studentList')">
                返回
            </div>
            </div>
              <div class="studentDetail-con">
        <div class="sdc-head">
            <div class="sdc-h-up flex align-cen">
                <div class="sdc-h-up-left flex align-cen">
                     <img :src="list.avatar || require('../../../../assets/images/head.png')" alt="" class="st-head-left-avatar">
                     <div class="left-info">
                        <div class="">
                            <span class="name">{{list.userName}}</span>
                             <div class="flex align-cen">
                                学员组分类：
                                 <div class="flex align-cen" style="justify-content:center" v-if="list.traineeClassifyRelationList && list.traineeClassifyRelationList.length">
                                <div v-for="(item,index) in list.traineeClassifyRelationList"  class="tagbq">
                                        {{item.classifyName}}
                                    </div>
                                    </div>
                                    <div v-else>-</div>
                                </div>
                                  <div class="logintime">最近登录：{{list.loginTime || '--'}}</div>
                        </div>
                     </div>
                </div>
            </div>
            <div class="sdc-h-down">
                <div class="sdc-h-down-data">
                    <div>
                        <span class="span1">手机：</span>
                        <span class="span2">{{list.loginName}}</span>
                    </div>
                    <div>
                        <span class="span1">所属公司：</span>
                        <span class="span2">{{list.businessName}}</span>
                    </div>
                </div>
           <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  试卷考试信息
            </div>
        </div>
        <div class="sdc-h-down-msg">
            <div class="sdc-h-down-msg-list">
                <div class="w-25">
                    <span>参与考试次数：</span>
                    <div>{{list.examInfo.examNum}}</div>
                </div>
                 <div class="w-25">
                    <span>百分比平均分：</span>
                    <div>{{list.examInfo.perAvgScore}}%</div>
                </div>
                 <div class="w-25">
                    <span>不及格次数：</span>
                    <div>{{list.examInfo.unPassNum}}</div>
                </div>
                 <div class="w-25">
                    <span>及格率：</span>
                    <div>{{list.examInfo.passRate}}%</div>
                </div>
            </div>
        </div>
          <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  仿真考试信息
            </div>
        </div>
              <div class="sdc-h-down-msg">
                    <div class="sdc-h-down-msg-list">
                <div class="w-25">
                    <span>参与仿真考试次数：</span>
                    <div>{{list.examInfo.assessNum}}</div>
                </div>
                 <div class="w-25">
                    <span>百分比平均分：</span>
                    <div>{{list.examInfo.assessPerAvgScore}}%</div>
                </div>
                 <div class="w-25">
                    <span>不及格次数：</span>
                    <div>{{list.examInfo.assessUnPassNum}}</div>
                </div>
                 <div class="w-25">
                    <span>及格率：</span>
                    <div>{{list.examInfo.assessPassRate}}%</div>
                </div>
            </div>
        </div>
            </div>
        </div>
        <div class="rdsdiv"></div>
        <div class="editUserInfo">
            <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 基本信息
                      </div>
                     <div class="public-btn mft"  @click="subUserinfo" v-if="editText">保存学员档案</div>
                     <div class="public-btn mft"  @click="subUserinfo1" v-if="!editText">编辑学员档案</div>
              </div>
              <div class="editUserInfo-tr editUserInfo-form" v-if="editText">
                  <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
                        <el-form-item label="学号：">
                    <el-input v-model="form.studentNum" placeholder="请输入学号" clearable 
                        maxlength="20"
                        minlength="1" 
                    ></el-input>
                </el-form-item>
                        <el-form-item label="身份证号：">
                    <el-input v-model="form.idNum" placeholder="请输入身份证号" clearable
                        maxlength="18"
                        minlength="1" 
                    ></el-input>
                </el-form-item>
                   <el-form-item label="学员协议：">
                   <el-upload
                    class="upload-demo"
                    ref="upload"
                    :action="$config.baseUrl + '/admin/sys-file/upload?businessId=' + businessInfo.id"
                     :headers="headers"
                    :file-list="fileList"
                     :on-success="scSuccess"
                     :on-remove="handleRemove"
                    >
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </el-form-item>
                 <el-form-item label="身份证信息：">
                    <el-upload
                    class="avatar-uploaderlogo"
                    :action="$config.baseUrl + '/admin/sys-file/upload?businessId='+ businessInfo.id"
                    :headers="headers"
                    list-type="picture-card"
                    :limit="2"
                     :file-list="moreImg"
                     :on-change="handleChange"
                    :before-upload="$util.beforeUpload"
                    :on-exceed="maxLenImg"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove1"
                     multiple
                    >
                     <i class="el-icon-plus"></i>
                     <div class="el-upload__tip" slot="tip">上传身份证正反面照片</div>
                      </el-upload>
                 </el-form-item>
                     <el-form-item label="入学简历：">
                   <el-upload
                    class="upload-demo"
                    ref="upload1"
                    :action="$config.baseUrl + '/admin/sys-file/upload?businessId=' + businessInfo.id"
                     :headers="headers"
                    :file-list="fileList1"
                    multiple
                     :on-success="scSuccess1"
                     :on-remove="handleRemove2"
                    >
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </el-form-item>
                       <el-form-item label="证件照：">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload?businessId=' + businessInfo.id"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    list-type="picture-card"
                    >
                    <img :src="form.photo" class="avatar" v-if="form.photo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <span v-if="form.photo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre(1)">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel(1)">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.photo" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
                   <div class="public-tit flex align-cen" ref="document" style="width:100%">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 财务记录
                      </div>
              </div>
                <el-form-item label="财务记录：" style="width:100%;margin-top:20px">
                    <el-upload
                    class="avatar-uploaderlogo"
                    :action="$config.baseUrl + '/admin/sys-file/upload?businessId='+ businessInfo.id"
                    :headers="headers"
                    list-type="picture-card"
                    :limit="100"
                     :file-list="moreImg1"
                     :on-change="handleChange1"
                    :before-upload="$util.beforeUpload"
                    :on-exceed="maxLenImg1"
                    :on-preview="handlePictureCardPreview1"
                    :on-remove="handleRemove3"
                     multiple
                    >
                     <i class="el-icon-plus"></i>
                     <div class="el-upload__tip" slot="tip">上传财务记录，支持多张</div>
                      </el-upload>
                 </el-form-item>
                  <div class="public-tit flex align-cen" ref="document" style="width:100%">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 安全管理
                      </div>
              </div>
                       <el-form-item label="安全资料：" style="width:100%;margin-top:20px">
                    <el-upload
                    class="avatar-uploaderlogo"
                    :action="$config.baseUrl + '/admin/sys-file/upload?businessId='+ businessInfo.id"
                    :headers="headers"
                    list-type="picture-card"
                    :limit="100"
                     :file-list="moreImg2"
                     :on-change="handleChange2"
                    :before-upload="$util.beforeUpload"
                    :on-exceed="maxLenImg2"
                    :on-preview="handlePictureCardPreview2"
                    :on-remove="handleRemove4"
                     multiple
                    >
                     <i class="el-icon-plus"></i>
                     <div class="el-upload__tip" slot="tip">请上传-支持多张（如安全承诺书、意外保险单）</div>
                      </el-upload>
                 </el-form-item>
                     <div class="public-tit flex align-cen" ref="document" style="width:100%">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 结业成果
                      </div>
              </div>
                 <el-form-item label="就业信息：" style="width:100%;margin-top:20px">
                    <el-upload
                    class="avatar-uploaderlogo"
                    :action="$config.baseUrl + '/admin/sys-file/upload?businessId='+ businessInfo.id"
                    :headers="headers"
                    list-type="picture-card"
                    :limit="100"
                     :file-list="moreImg3"
                     :on-change="handleChange3"
                    :before-upload="$util.beforeUpload"
                    :on-exceed="maxLenImg3"
                    :on-preview="handlePictureCardPreview3"
                    :on-remove="handleRemove5"
                     multiple
                    >
                     <i class="el-icon-plus"></i>
                     <div class="el-upload__tip" slot="tip">请上传-支持多张</div>
                      </el-upload>
                 </el-form-item>
                  <div class="public-tit flex align-cen" ref="document" style="width:100%">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 增值记录
                      </div>
              </div>
                 <el-form-item label="获奖证书：" style="width:100%;margin-top:20px">
                    <el-upload
                    class="avatar-uploaderlogo"
                    :action="$config.baseUrl + '/admin/sys-file/upload?businessId='+ businessInfo.id"
                    :headers="headers"
                    list-type="picture-card"
                    :limit="100"
                     :file-list="moreImg4"
                     :on-change="handleChange4"
                    :before-upload="$util.beforeUpload"
                    :on-exceed="maxLenImg4"
                    :on-preview="handlePictureCardPreview4"
                    :on-remove="handleRemove6"
                     multiple
                    >
                     <i class="el-icon-plus"></i>
                     <div class="el-upload__tip" slot="tip">请上传-支持多张</div>
                      </el-upload>
                 </el-form-item>
                  </el-form>
              </div>
              <div class="editUserInfo-form editUserInfo-fa" v-if="!editText">
                       <div class="sdc-h-down-msg">
                      <div class="sdc-h-down-msg-list">
                <div class="w-25">
                    <span>学号：</span>
                    <div>{{list.studentNum}}</div>
                </div>
                 <div class="w-25">
                    <span>身份证号：</span>
                    <div>{{list.idNum}}</div>
                </div>
                  <div class="w-25">
                    <span>学员协议：</span>
                    <div style="font-size:13px" v-for="item in agreementArr" class="flex align-cen">
                      <span  style="color:#000">{{item}}</span>
                      <span class="mft public-btn" style="color:#fff;padding:2px 10px" @click="openBl(item)">查看</span>
                    </div>
                </div>
                 <div class="w-25">
                    <span>入学简历：</span>
                    <div style="font-size:13px" v-for="item in resumeArr" class="flex align-cen">
                      <span  style="color:#000">{{item}}</span>
                      <span class="mft public-btn" style="color:#fff;padding:2px 10px" @click="openBl(item)">查看</span>
                    </div>
                </div>
                 <div class="w-25">
                    <span>身份证信息：</span>
                    <div class="img-card flex align-cen">
                        <img :src="item.url" alt="" v-for="(item,index) in moreImg" @click="handlePictureCardPreview({url:item.url})">
                    </div>
                </div>
                <div class="w-25">
                    <span>证件照：</span>
                    <div class="img-card">
                      <img :src="form.photo" alt="证件照"  v-if="form.photo" @click="handlePictureCardPreview({url:form.photo})">
                    </div>
                </div>
            </div>
        </div>
            <div class="public-tit flex align-cen" ref="document" style="margin-top:10px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 财务记录
                      </div>
              </div>
                      <div class="sdc-h-down-msg">
                      <div class="sdc-h-down-msg-list">
                <div class="w-100 w-25">
                    <span>财务记录：</span>
                   <div class="img-card flex align-cen">
                        <img :src="item.url" alt="" v-for="(item,index) in moreImg1" @click="handlePictureCardPreview({url:item.url})" >
                    </div>
                </div>
            </div>
        </div>
          <div class="public-tit flex align-cen" ref="document" style="margin-top:10px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 安全管理
                      </div>
              </div>
                      <div class="sdc-h-down-msg">
                      <div class="sdc-h-down-msg-list">
                <div class="w-100 w-25">
                    <span>安全资料：</span>
                   <div class="img-card flex align-cen">
                        <img :src="item.url" alt="" v-for="(item,index) in moreImg2" @click="handlePictureCardPreview({url:item.url})" >
                    </div>
                </div>
            </div>
        </div>
          <div class="public-tit flex align-cen" ref="document" style="margin-top:10px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 结业成果
                      </div>
              </div>
               <div class="App-tab" style="margin-top:16px">
                     <el-table
                        :data="itemList4"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                        >
                         <el-table-column label="证书名称" align="center">
                            <template slot-scope="scope">
                        <p>{{scope.row.certName}}</p>
                        </template>
                    </el-table-column> 
                     <el-table-column label="证书编号" align="center" prop="certificateNo">
                      </el-table-column>
                        <el-table-column label="证书类型" align="center" prop="classifyName">
                        </el-table-column>    
                         <el-table-column label="发放日期" align="center" prop="issueTime">
                      </el-table-column>
                       <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"       
                    >
                      <template slot-scope="scope">
                        <!--  -->
                        <el-button type="text" style="color:red" @click="uploadCert(scope.row)" :loading="certLoading">下载证书</el-button> 
                     </template>
                   </el-table-column>
                     </el-table>
                         <paginaTion :total="totalCount4" :type="4" @sendStatus="emitFun"></paginaTion>
               </div>
                            <div class="sdc-h-down-msg">
                      <div class="sdc-h-down-msg-list">
                <div class="w-100 w-25">
                    <span>就业信息：</span>
                   <div class="img-card flex align-cen">
                        <img :src="item.url" alt="" v-for="(item,index) in moreImg3" @click="handlePictureCardPreview({url:item.url})" >
                    </div>
                </div>
            </div>
        </div>
          <div class="public-tit flex align-cen" ref="document" style="margin-top:10px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 增值记录
                      </div>
              </div>
                            <div class="sdc-h-down-msg">
                      <div class="sdc-h-down-msg-list">
                <div class="w-100 w-25">
                    <span>获奖证书：</span>
                   <div class="img-card flex align-cen">
                        <img :src="item.url" alt="" v-for="(item,index) in moreImg4" @click="handlePictureCardPreview({url:item.url})" >
                    </div>
                </div>
            </div>
        </div>
              </div>
                                  <el-dialog :visible.sync="dialogVisible" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                      <el-dialog :visible.sync="dialogVisible1" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="dialogImageUrl1" alt="">
                    </el-dialog>
                       <el-dialog :visible.sync="dialogVisible2" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="dialogImageUrl2" alt="">
                    </el-dialog>
                      <el-dialog :visible.sync="dialogVisible3" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="dialogImageUrl3" alt="">
                    </el-dialog>
                    <el-dialog :visible.sync="dialogVisible4" size="tiny"  :append-to-body="true">
                      <img width="100%" :src="dialogImageUrl4" alt="">
                    </el-dialog>
        </div>
         <div class="rdsdiv"></div>
         <div class="paper-content">
          <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 学员课程
                      </div>
                      <div class="regulaOption flex align-cen mft">
                      <el-select v-model="studentValue"  clearable placeholder="课程分类"
                      >
                        <el-option value="">全部</el-option>
                          <el-option
                          v-for="item in studentValueOption"
                          :key="item.name"
                          :label="item.name"
                          :value="item.id">
                          </el-option>
                      </el-select>
                  </div>
              </div>
                                  <div class="exams-list">
                            <div class="exams-scrollbar" v-if="itemList5 && itemList5.length" style="margin-top: 16px;">
                                <div class="exams-item" v-for="(item,index) in itemList5" >
                                    <div class="exams-item-info flex align-cen">
                                         <img :src="item.logo" alt="" class="courseimg">
                                         <div class="exams-item-info-rule flex">
                                            <div class="exams-item-paperName flg">
                                                    {{item.title}}
                                                </div>
                                                <div class="dateTit flg" style="margin:20px 0;margin-right:20px">
                                                    {{item.introduction}}
                                                </div>
                                                 <div class="dateTit  dateTit1 flg " style="margin-bottom:20px">
                                                    <span style="color:red;"  v-if="item.endTime">{{item.endTime}} 到期</span>
                                                    <span v-else>时间不限</span>
                                                </div>
                                                 <div class="dateTit dateTit1 flg flex">
                                                    <span >已更新{{item.chapterNum}}期</span>
                                                </div>
                                         </div>
                                         <div class="mft">
                                            <span class="coursebtn" @click="openCourseDetail(item)">
                                                查看详情
                                            </span>
                                         </div>
                                    </div>
                                </div>
                            </div>
                          <div class="exams-scrollbar" v-else>
                                <el-empty>
                            </el-empty>
                            </div>
                          </div>
         </div>
          <div class="rdsdiv"></div>
          <div class="paper-content">
                <div class="public-tit flex align-cen" ref="document" style="margin-top:10px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 学习记录
                      </div>
              </div>
               <div class="App-tab" style="margin-top:16px">
                     <el-table
                        :data="itemList6"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                        >
                         <el-table-column label="课程名称" align="center">
                            <template slot-scope="scope">
                                <div>
                                  <img :src="scope.row.logo" alt="" style="width:100px;height:60px">
                                  <span style="margin-left:10px">{{scope.row.courseName}}</span>
                                </div>
                        </template>
                    </el-table-column> 
                        <el-table-column label="章节名称" align="center">
                           <template slot-scope="scope">
                                <div>
                          <p> {{scope.row.lastRecordChapterMap.parentHeadline}} {{scope.row.lastRecordChapterMap.serialNum}}{{scope.row.lastRecordChapterMap.headline}}</p>
                                </div>
                        </template>
                        </el-table-column>    
                         <el-table-column label="开始时间" align="center" prop="firstTime">
                      </el-table-column>
                       <el-table-column label="学习进度" align="center">
                           <template slot-scope="scope">
                                <div>
                          <p> {{scope.row.progress}}%</p>
                                </div>
                        </template>
                      </el-table-column>
                     </el-table>
                         <paginaTion :total="totalCount5" :type="5" @sendStatus="emitFun"></paginaTion>
               </div>
          </div>
           <div class="rdsdiv"></div>
         <div class="paper-content" id="paperIDPd">
              <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i> 试卷考试图表统计
                            </div>
              </div>
              <div class="chat-flex flex">
                              <div class="student-detailds-chart">
                <div class="student-detailds-chart-head flex align-cen">
                    <span data-title="分类知识点答题正确率">正式考试分类知识点答题正确率</span>
                    <div class="yks-blue" @click="openy(0,'web')">查看全部</div>
                </div>
                <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                         <BarChart :option="BarChartOption1" :barID="'barID1'" :isFz="'web'"></BarChart>
                    </div>
                </div>
              </div>
                            <div class="student-detailds-chart" style="padding-left:12px">
                <div class="student-detailds-chart-head flex align-cen">
                    <span data-title="分类知识点答题正确率">练习模式分类知识点答题正确率</span>
                    <div class="yks-blue" @click="openy(1,'web')">查看全部</div>
                </div>
                <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                         <BarChart :option="BarChartOption" :barID="'barID'" :isFz="'web'"></BarChart>
                    </div>
                </div>
              </div>
              </div>
               <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i> 考生成绩变化趋势
                            </div>
              </div>
               <div class="chat-flex flex">
            <div class="student-detailds-chart">
                <div class="student-detailds-chart-head flex align-cen">
                    <span data-title="分类知识点答题正确率">正式考试考生成绩变化趋势</span>
                             <div class="businessList-filter-list flex align-cen" style="margin-left:auto">
                            <div class="label">自定义查询时间：</div>
                            <el-date-picker
                            v-model="value2"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect(0)"
                            >
                            </el-date-picker>
                        </div>
                </div>
                 <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                      <lineChart :option="LineChartOption" :barID="'lineID'"></lineChart>
                    </div>
                </div>
            </div>
             <div class="student-detailds-chart" style="padding-left:12px">
                <div class="student-detailds-chart-head flex align-cen">
                    <span data-title="分类知识点答题正确率">练习模式考生成绩变化趋势</span>
                             <div class="businessList-filter-list flex align-cen" style="margin-left:auto">
                            <div class="label">自定义查询时间：</div>
                            <el-date-picker
                            v-model="value3"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect1(1)"
                            >
                            </el-date-picker>
                        </div>
                </div>
                 <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                      <lineChart :option="LineChartOption1" :barID="'lineID1'"></lineChart>
                    </div>
                </div>
            </div>
        </div>
         </div>
         <div class="rdsdiv"></div>
         <div class="paper-content">
             <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
            <div class="public-tit-list">
                <i class="icon-al-application"></i> 参与考试的试卷
            </div>
              </div>
               <div class="App-tab" style="margin-top:16px">
                     <el-table
                        :data="itemList0"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                        >
                         <el-table-column label="序号" align="center">
                            <template slot-scope="scope">
                        <p>{{Number(scope.$index) + 1}}</p>
                        </template>
                    </el-table-column> 
                    <el-table-column label="状态" align="center">
                            <template slot-scope="scope">
                        <p :class="getStatu(scope.row.state,2)">
                            <i class="el-icon-s-opportunity"></i>
                            {{getStatu(scope.row.state,1)}}
                        </p>
                        </template>
                    </el-table-column> 
                     <el-table-column label="完成比例" align="center" prop="finishRate">
                      </el-table-column>
                        <el-table-column label="得分" align="center" prop="userScore">
                      </el-table-column>
                          <el-table-column label="试卷百分比得分" align="center" prop="scoreRate">
                                 <template slot-scope="scope">
                        <p>{{scope.row.scoreRate}}%</p>
                        </template>

                      </el-table-column>
                         <el-table-column label="考试时间" align="center" prop="startTime">
                      </el-table-column>
                        <el-table-column label="用时" align="center">
                               <template slot-scope="scope">
                        <p>{{$util.convertSecondsToMinutes(scope.row.doTime,1)}}</p>
                        </template>
                      </el-table-column>
                       <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"       
                    >
                      <template slot-scope="scope">
                        <el-button type="text" style="color:red" v-if="scope.row.state == 1" @click.stop="getResulttRanscript(scope.row)">查看详情</el-button> 
                         <el-button type="text" style="color:red" v-if="scope.row.state == 0">-</el-button> 
                     </template>
                   </el-table-column>
                     </el-table>
                       <paginaTion :total="totalCount0" :type="0" @sendStatus="emitFun"></paginaTion>
               </div>
                 <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
            <div class="public-tit-list">
                <i class="icon-al-application"></i> 参与练习的试卷
            </div>
              </div>
                             <div class="App-tab" style="margin-top:16px">
                     <el-table
                        :data="itemList1"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                        >
                         <el-table-column label="序号" align="center">
                            <template slot-scope="scope">
                        <p>{{Number(scope.$index) + 1}}</p>
                        </template>
                    </el-table-column> 
                    <el-table-column label="状态" align="center">
                            <template slot-scope="scope">
                        <p :class="getStatu(scope.row.state,2)">
                            <i class="el-icon-s-opportunity"></i>
                            {{getStatu(scope.row.state,1)}}
                        </p>
                        </template>
                    </el-table-column> 
                     <el-table-column label="完成比例" align="center" prop="finishRate">
                      </el-table-column>
                        <el-table-column label="得分" align="center" prop="userScore">
                      </el-table-column>
                          <el-table-column label="试卷百分比得分" align="center" prop="scoreRate">
                                   <template slot-scope="scope">
                        <p>{{scope.row.scoreRate}}%</p>
                        </template>
                      </el-table-column>
                         <el-table-column label="考试时间" align="center" prop="startTime">
                      </el-table-column>
                        <el-table-column label="用时" align="center">
                               <template slot-scope="scope">
                        <p>{{$util.convertSecondsToMinutes(scope.row.doTime,1)}}</p>
                        </template>
                      </el-table-column>
                       <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"       
                    >
                      <template slot-scope="scope">
                        <el-button type="text" style="color:red" v-if="scope.row.state == 1" @click.stop="getResulttRanscript(scope.row)">查看详情</el-button> 
                         <el-button type="text" style="color:red" v-if="scope.row.state == 0">-</el-button> 
                     </template>
                   </el-table-column>
                     </el-table>
                         <paginaTion :total="totalCount1" :type="1" @sendStatus="emitFun"></paginaTion>
               </div>
         </div>
           <div class="rdsdiv"></div>
         <div class="paper-content">
            <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                <div class="public-tit-list">
                    <i class="icon-al-application"></i> 仿真考试图表统计
                </div>
              </div>
                    <div class="chat-flex flex">
                              <div class="student-detailds-chart">
                <div class="student-detailds-chart-head flex align-cen">
                    <span data-title="分类知识点答题正确率">正式考试分类知识点答题正确率</span>
                    <div class="yks-blue" @click="openy(0,'fz')">查看全部</div>
                </div>
                <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                         <BarChart :option="BarChartOption3" :barID="'barID3'" :isFz="'fz'"></BarChart>
                    </div>
                </div>
              </div>
                            <div class="student-detailds-chart" style="padding-left:12px">
                <div class="student-detailds-chart-head flex align-cen">
                    <span data-title="分类知识点答题正确率">练习模式分类知识点答题正确率</span>
                    <div class="yks-blue" @click="openy(1,'fz')">查看全部</div>
                </div>
                <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                         <BarChart :option="BarChartOption2" :barID="'barID2'" :isFz="'fz'"></BarChart>
                    </div>
                </div>
              </div>
         </div>
           <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i> 考生仿真成绩变化趋势
                            </div>
              </div>
                           <div class="chat-flex flex">
            <div class="student-detailds-chart">
                <div class="student-detailds-chart-head flex align-cen">
                    <span data-title="分类知识点答题正确率">正式考试考生成绩变化趋势</span>
                             <div class="businessList-filter-list flex align-cen" style="margin-left:auto">
                            <div class="label">自定义查询时间：</div>
                            <el-date-picker
                            v-model="value4"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect2(0)"
                            >
                            </el-date-picker>
                        </div>
                </div>
                 <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                      <lineChart :option="LineChartOption2" :barID="'lineID2'"></lineChart>
                    </div>
                </div>
            </div>
             <div class="student-detailds-chart" style="padding-left:12px">
                <div class="student-detailds-chart-head flex align-cen">
                    <span data-title="分类知识点答题正确率">练习模式考生成绩变化趋势</span>
                             <div class="businessList-filter-list flex align-cen" style="margin-left:auto">
                            <div class="label">自定义查询时间：</div>
                            <el-date-picker
                            v-model="value5"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect3(1)"
                            >
                            </el-date-picker>
                        </div>
                </div>
                 <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                      <lineChart :option="LineChartOption3" :barID="'lineID3'"></lineChart>
                    </div>
                </div>
            </div>
        </div>
         </div>
         <div class="rdsdiv"></div>
         <div class="paper-content">
             <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
            <div class="public-tit-list">
                <i class="icon-al-application"></i> 参与仿真考试的试卷
            </div>
              </div>
               <div class="App-tab" style="margin-top:16px">
                     <el-table
                        :data="itemList2"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                        >
                         <el-table-column label="序号" align="center">
                            <template slot-scope="scope">
                        <p>{{Number(scope.$index) + 1}}</p>
                        </template>
                    </el-table-column> 
                    <el-table-column label="状态" align="center">
                            <template slot-scope="scope">
                        <p :class="getStatu(scope.row.state,2)">
                            <i class="el-icon-s-opportunity"></i>
                            {{getStatu(scope.row.state,1)}}
                        </p>
                        </template>
                    </el-table-column> 
                     <el-table-column label="完成比例" align="center" prop="finishRate">
                      </el-table-column>
                        <el-table-column label="得分" align="center" prop="userScore">
                      </el-table-column>
                          <el-table-column label="试卷百分比得分" align="center" prop="scoreRate">
                                 <template slot-scope="scope">
                        <p>{{scope.row.scoreRate}}%</p>
                        </template>

                      </el-table-column>
                         <el-table-column label="考试时间" align="center" prop="startTime">
                      </el-table-column>
                        <el-table-column label="用时" align="center">
                               <template slot-scope="scope">
                        <p>{{$util.convertSecondsToMinutes(scope.row.doTime,1)}}</p>
                        </template>
                      </el-table-column>
                       <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"       
                    >
                      <template slot-scope="scope">
                        <el-button type="text" style="color:red" v-if="scope.row.state == 1" @click.stop="getResulttRanscript1(scope.row)">查看详情</el-button> 
                         <el-button type="text" style="color:red" v-if="scope.row.state == 0">-</el-button> 
                     </template>
                   </el-table-column>
                     </el-table>
                       <paginaTion :total="totalCount2" :type="2" @sendStatus="emitFun"></paginaTion>
               </div>
                 <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
            <div class="public-tit-list">
                <i class="icon-al-application"></i> 参与仿真练习的试卷
            </div>
              </div>
                             <div class="App-tab" style="margin-top:16px">
                     <el-table
                        :data="itemList3"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                        >
                         <el-table-column label="序号" align="center">
                            <template slot-scope="scope">
                        <p>{{Number(scope.$index) + 1}}</p>
                        </template>
                    </el-table-column> 
                    <el-table-column label="状态" align="center">
                            <template slot-scope="scope">
                        <p :class="getStatu(scope.row.state,2)">
                            <i class="el-icon-s-opportunity"></i>
                            {{getStatu(scope.row.state,1)}}
                        </p>
                        </template>
                    </el-table-column> 
                     <el-table-column label="完成比例" align="center" prop="finishRate">
                      </el-table-column>
                        <el-table-column label="得分" align="center" prop="userScore">
                      </el-table-column>
                          <el-table-column label="试卷百分比得分" align="center" prop="scoreRate">
                                   <template slot-scope="scope">
                        <p>{{scope.row.scoreRate}}%</p>
                        </template>
                      </el-table-column>
                         <el-table-column label="考试时间" align="center" prop="startTime">
                      </el-table-column>
                        <el-table-column label="用时" align="center">
                               <template slot-scope="scope">
                        <p>{{$util.convertSecondsToMinutes(scope.row.doTime,1)}}</p>
                        </template>
                      </el-table-column>
                       <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"       
                    >
                      <template slot-scope="scope">
                        <!--  -->
                        <el-button type="text" style="color:red" v-if="scope.row.state == 1" @click.stop="getResulttRanscript1(scope.row)">查看详情</el-button> 
                         <el-button type="text" style="color:red" v-if="scope.row.state == 0">-</el-button> 
                     </template>
                   </el-table-column>
                     </el-table>
                         <paginaTion :total="totalCount3" :type="3" @sendStatus="emitFun"></paginaTion>
               </div>
         </div>
              </div>
         <!-- 打开 -->
      <el-dialog
  :title="title"
  :visible.sync="centerDialogVisible"
  width="35%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible"
  >
   <div class="jBox-content">
    <el-table
    :data="tabletype == 0 ? segmentData : segmentData1"
    border
    stripe
    style="width: 100%">
    <el-table-column
      :label="tableName=='web' ? '分类' : '应用'"
      :prop="tableName=='web' ? 'classifyName' : 'appName'"
      >
    </el-table-column>
       <el-table-column
      prop="rate"
      label="正确率"
      >
             <template slot-scope="scope">
                        <p>{{scope.row.rate}}%</p>
                        </template>
    </el-table-column>
    </el-table>
   </div>
      </el-dialog>
            <el-dialog
            title="查看成绩单"
            :visible.sync="centerDialogVisible1"
            width="40%"
            :append-to-body="true"
            center
            custom-class="publicDialogClass"
            >
             <el-tabs  v-model="activeName">
                      <el-tab-pane label="本次成绩" name="1">
            <div class="print-tab-content">
                <div class="tester-info">
                    <p class="text">{{testerInfo.paperName}}</p>
                    <p class="text">考试者：{{testerInfo.examiner}}</p>
                    <p class="lastP">
                        开始时间：{{testerInfo.startTime}} | 交卷时间：{{testerInfo.answerTime}} 
                    </p>
                    <div class="sorceRow">
                        <div class="result-scores">
                            <div class="exam-record-info">
                                <p class="score-num">{{testerInfo.userScore}}
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf">(总分{{testerInfo.paperScore}}分)</div>
                             <div class="zf">用时：{{$util.convertSecondsToMinutes(testerInfo.doTime,2)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
                <el-tab-pane label="答题分析" name="2">
             <div>
    <el-radio-group v-model="radio" @change="getQuestionListCom(radio)">
      <el-radio-button label="1">
        答对（{{testerInfo.rightNum}}）
      </el-radio-button>
      <el-radio-button label="2">
        答错（{{testerInfo.wrongNum}}）
      </el-radio-button>
      <el-radio-button label="3">
        未答（{{testerInfo.unAnswerNum}}）
      </el-radio-button>
      <el-radio-button label="4">
        全部试题（{{testerInfo.questionNum}}）
      </el-radio-button>
    </el-radio-group>
        <div class="watermark">
            <div class="question">
                <div class="question-main-content" v-if="questionList.length">
                    <div class="row" v-for="(item,index) in questionList" :key="item.id">
                        <div class="ques-title flex align-cen">
                            <span class="ques-number">{{index+1}}.</span>
                            <span class="ques-type" style="margin:0 12px">
                                 [{{item.type == 1 ? '单选题' : item.type == 2 ? '多选题' : item.type== 3 ? '判断题' : item.type == 4 ? '填空题' : ''}}]
                            </span>
                            <span v-html="item.title" style="max-width:75%"></span>
                            <span class="ques-score">（{{item.questionScore}}分）</span>
                        </div>
                          <div class="question-option-list">
                            <ol>
                                <li v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                    <p v-html="sonitem.content"></p>
                                </li>
                            </ol>
                          </div>
                        <div class="ques-answers">
                            <div class="test_result flex align-cen">
                                <div class="userAnswer">
                                    <div class="test_result_span_title">考生答案：</div>
                                    <strong :class="item.doRight == 1 ? 'true' : 'false'" v-if="item.isAnswer == '1'">
                                        {{item.answerContent}}
                                        <i :class="item.doRight == 1 ? 'icon-al-check' : 'icon-al-times'"></i>
                                    </strong>
                                    <span v-else>未作答</span>
                                </div>
                                <div class="rightAnswer">
                                     <div class="test_result_span_title">正确答案：</div>
                                        <div class="dnl flex">
                                            <span v-for="(sonitem,sonIndex) in item.questionAnswerList">
                                        <strong  v-if="sonitem.isRight == 1">
                                        {{Eng[sonIndex]}}
                                    </strong>
                                    </span>
                                    </div>
                                </div>
                                <div class="score">
                                    <div class="test_result_span_title">分数：</div>
                                    <strong style="color: #36aafd">
                                       {{item.customerScore || 0}} / {{item.questionScore}}分
                                    </strong>
                                </div>
                            </div>
                        </div>
                          <div class="jx flex align-cen">
                            题目解析：<span v-html="item.analysis || '暂无解析'"></span>
                         </div>
                    </div>
                </div>
                <div v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
  </div>
        </el-tab-pane>
               <el-tab-pane label="后台监考" name="3">
            <div class="actions-list" style="padding:0 10px">
                <el-timeline>
                     <el-timeline-item
                    v-for="(activity, index) in resultLogList"
                    :key="index"
                    :type="'success'"
                    :color="'#36aafd'"
                    :size="'large'"
                    placement="top"
                    :timestamp="activity.createTime">
                    <el-card>
                    <h4>{{activity.operate}}</h4>
                    <p> ip:{{activity.ip}}</p>
                </el-card>
                  
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-tab-pane>
             </el-tabs>
            </el-dialog>
            <!-- 打开仿真成绩单 -->
            <el-dialog
  title="查看成绩单"
  :visible.sync="centerDialogVisible2"
  width="40%"
  :append-to-body="true"
  center
  custom-class="paperDialogClass publicDialogClass"
  v-if="centerDialogVisible2"
  >
    <el-tabs  v-model="activeName1">
        <el-tab-pane label="本次成绩" name="1">
            <div class="print-tab-content">
                <div class="tester-info">
                    <p class="text">{{testerInfo1.paperName}}</p>
                    <p class="text">考试者：{{testerInfo1.examiner}}</p>
                    <p class="lastP">
                        开始时间：{{testerInfo1.startTime}} | 交卷时间：{{testerInfo1.answerTime}} 
                    </p>
                    <div class="sorceRow">
                         <div class="result-scores">
                            <div class="exam-record-info" v-if="testerInfo1.result !=2">
                                <p class="score-num">{{testerInfo1.userScore}}
                                    <span>分</span>
                                </p>
                            </div>
                            <div class="zf"  v-if="testerInfo1.result !=2">(总分{{testerInfo1.paperScore}}分)</div>
                            <div class="reult2" v-if="testerInfo1.result ==2">
                                <div class="reult2_tip">答题已结束，感谢您的参加</div>
                                <div class="reult2_pj">请等待老师批卷，批卷完成后将展示成绩</div>
                            </div>
                             <div class="zf">用时：{{$util.convertSecondsToMinutes(testerInfo1.doTime,2)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="答题分析" name="2">
             <div>
    <el-radio-group v-model="radio1" @change="getQuestionListCom1(radio1)">
      <el-radio-button label="1">
        答错（{{testerInfo1.wrongNum}}）
      </el-radio-button>
      <el-radio-button label="2">
        得分（{{testerInfo1.rightNum}}）
      </el-radio-button>
      <el-radio-button label="3">
        全部步骤（{{testerInfo1.stepNum}}）
      </el-radio-button>
    </el-radio-group>
        <div class="watermark">
            <div class="question">
                <div class="question-main-content" v-if="questionList1.length">
                       <div class="public-tit flex align-cen" style="margin-bottom:10px">
                      <div class="public-tit-list">
                          <i class="icon-al-database-fill"></i>  过程
                      </div>
                  </div>
                           <el-table
                    :data="processList"
                    border
                    style="width: 100%"
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                        <el-table-column prop="processName" label="过程名称" align="center" >
                        </el-table-column>
                         <el-table-column  label="起始条件"  width="300">
                          <template slot-scope="scope">
                            <div class="flex justify-content-cen">
                              <div v-for="(item,pindex) in scope.row.startCondition" :key="pindex" class="flex ">
                                 <span class="textR">{{item.cond1}}</span>{{item.tag}} {{item.name}}{{item.tj}}{{item.tj1}}
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                          <el-table-column  label="结束条件"  width="300">
                            <template slot-scope="scope">
                            <div class="flex justify-content-cen">
                              <div v-for="(item,pindex) in scope.row.endCondition" :key="pindex" class="flex">
                                <span class="textR">{{item.cond1}}</span>{{item.tag}} {{item.name}}{{item.tj}}{{item.tj1}}
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                </el-table>
                        <div class="public-tit flex align-cen" style="margin:10px 0">
                      <div class="public-tit-list">
                          <i class="icon-al-database-fill"></i>  步骤
                      </div>
                  </div>
                          <el-table
                    :data="questionList1"
                    border
                    style="width: 100%"
                    :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                        <el-table-column prop="processName" label="关联过程" align="center" >
                        </el-table-column>
                         <el-table-column  prop="stepName" label="步骤名称" align="center">
                        </el-table-column>
                          <el-table-column  label="得分"  align="center">
                            <template slot-scope="scope">
                             <span class="textR"> {{scope.row.customerScore}}</span> / <span>{{scope.row.score}}</span>
                          </template>
                        </el-table-column>
                </el-table>
                </div>
                <div v-else>
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
  </div>
        </el-tab-pane>
        <el-tab-pane label="后台监考" name="3">
            <div class="actions-list" style="padding:0 10px">
                <el-timeline>
                     <el-timeline-item
                    v-for="(activity, index) in resultLogList1"
                    :key="index"
                    :type="'success'"
                    :color="'#36aafd'"
                    :size="'large'"
                    placement="top"
                    :timestamp="activity.createTime">
                    <el-card>
                    <h4>{{activity.operate}}</h4>
                    <p> ip:{{activity.ip}}</p>
                </el-card>
                  
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-tab-pane>
        </el-tabs>
      </el-dialog>
         <certTemplate ref="certTemplate" 
            :propId='propId' 
            :arrType="arrType"
             @sendStatus2="closeTem" 
             v-if="cenrterDialogVisible1">
             </certTemplate>
    </div>
</template>
<script>
import { getStudentDetail,countRateQuestionClassifyList,rasoCountResultRateByApp,listDailyScore,rasoListDailyScore,listExamResult,rasoListExamResult,resulttRanscript,rasoResulttRanscript,saveTrainee,getcertList,courseClassify,courserMyList,courserRecordList} from "@/api/enterprise/index"; // 学员详情、分类知识点答题正确率、仿真分类知识点答题正确率、考生成绩变化、参与考试的试卷、编辑学员详情、学员证书分页、课程分类、我的课程、学习记录
import BarChart from "../../../../components/barTemplate/index.vue"; //柱状图图组件
import lineChart from "@/components/lineTemolate/index.vue"; //折线图图组件
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import certTemplate from "@/webenterprise/enCert/index.vue"; //将证书页面作为组件使用
export default {
    name:'studentDetail',
    components:{
      BarChart,
      lineChart,
      paginaTion,
      certTemplate
    },
    data() {
        return {
          agreementArr:[],
          resumArr:[],
          studentValueOption:[],
          studentValue:'',
          arrType:'',
          propId:'',
          cenrterDialogVisible1:false,
          certLoading:false,
          userInfo:{},
          oploadDialogVisible:false,
          uploadBoolean:false,
          fileList1:[],
           dialogImageUrl4:'',
          dialogVisible4:false,
          dialogImageUrl3:'',
          dialogVisible3:false,
          dialogImageUrl2:'',
          dialogVisible2:false,
          dialogImageUrl1:'',
          dialogVisible1:false,
          dialogImageUrl:'',
          dialogVisible:false,
          moreImg:[],
          moreImg1:[],
          moreImg2:[],
          moreImg3:[],
          moreImg4:[],
          businessInfo:{},
          fileList:[],
          headers:{},
          rules:{},
          form:{
            studentNum:'',
            idNum:'',
            agreement:'',
            resume:'',
            photo:'',
            financial:'',
            safety:'',
            employ:'',
            award:'',

          },
          editText:false,
          propData:{},
            stepList:[],
          processList:[],
             Eng:['A','B','C','D','E','F','G','H','I','J'],
            resultQuestionVOList:[],
            resultLogList:[],
            resultQuestionVOList1:[],
            resultLogList1:[],
            radio:'1',
            radio1:'1',
            questionList:[],
            questionList1:[],
            testerInfo:{},
            testerInfo1:{},
            activeName:'1',
            activeName1:'1',
            centerDialogVisible1:false,
            centerDialogVisible2:false,
            currentPage0: 1, //初始页
            PageSize0: 10, //每页的数据
            totalCount0:0,
            currentPage1: 1, //初始页
            PageSize1: 10, //每页的数据
            totalCount1:0,
            currentPage2: 1, //初始页
            PageSize2: 10, //每页的数据
            totalCount2:0,
            currentPage3: 1, //初始页
            PageSize3: 10, //每页的数据
            totalCount3:0,
            currentPage4: 1, //初始页
            PageSize4: 10, //每页的数据
            totalCount4:0,
            currentPage5: 1, //初始页
            PageSize5: 10, //每页的数据
            totalCount5:0,
            itemList0:[],
            itemList1:[],
            itemList2:[],
            itemList3:[],
            itemList4:[],
            itemList5:[],
            itemList6:[],
            value2:[],
            value3:[],
            value4:[],
            value5:[],
            starTime:'',
            endTime:'',
            starTime1:'',
            endTime1:'',
             starTime2:'',
            endTime2:'',
              starTime3:'',
            endTime3:'',
            tabletype:0,
            tableName:'',
            title:'分类知识点答题正确率',
            centerDialogVisible:false,
            list:{
                examInfo:{}
            },
             BarChartOption:{},
             BarChartOption1:{},
             BarChartOption2:{},
             BarChartOption3:{},
             LineChartOption:{},
             LineChartOption1:{},
              LineChartOption2:{},
             LineChartOption3:{},
             segmentData:[],
            segmentData1:[],
            pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
    created() {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.userInfo = this.$locaStorage.setAge().get('userinfo1')
        this.getthisInfo() 
        this.getClass()
        this.getcouList()
        this.getcoureWater()
        this.getCountRate(0)
        this.getCountRate(1)
         this.getCountRate1(0)
        this.getCountRate1(1)
        this.getlistDailyScore(0)
        this.getlistDailyScore(1)
         this.getlistDailyScore1(0)
        this.getlistDailyScore1(1)
        this.getlistExamResult(0)
        this.getlistExamResult(1)
         this.getlistExamResult1(2)
        this.getlistExamResult1(3)
           let token = this.$locaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
      openBl(url){
         window.open(url)
      },
          // 获取学习记录分页
        getcoureWater(){
            courserRecordList({businessId:this.businessInfo.id,size:this.PageSize5, current:this.currentPage5})
            .then(res =>{
                this.itemList6 = res.data.records
                this.totalCount5 = res.data.total
            })
        },
      // 打开课程详情
      openCourseDetail(data){
         const newurl = this.$router.resolve({name: 'HlrjenCourseDetail', query: {id: data.id}})
       window.open(newurl.href,'_blank')
      },
         // 获取学习记录分页
        getcouList(){
            courserMyList({businessId:this.businessInfo.id,classifyId:this.studentValue,accountId:this.$route.query.id})
            .then(res =>{
              console.log(res)
                this.itemList5 = res.data
            })
        },
        // 获取课程分类
            getClass(){
            courseClassify({name:''})
            .then(res =>{
                this.studentValueOption = res.data
            })
        },
       // 关闭证书
    closeTem(val){
        this.propId = ''
        this.centerDialogVisible1 = false
        this.certLoading = false
    },
       // 下载证书
    uploadCert(data){
      this.arrType = ""
        this.propId = data.id
        this.cenrterDialogVisible1 = true
        this.certLoading = true
        //  const newurl = this.$router.resolve({name: 'enCert', query: {id: data.id}})
        // window.open(newurl.href,'_blank')
    },
      // 获取学员证书列表
      getthisCert(){
        let params = {
                businessId:this.$route.query.businessId,
                classifyId:'',
                phone:this.list.loginName,
                size:this.PageSize4,
                current:this.currentPage4,
        }
        getcertList(params)
        .then(res =>{
          this.itemList4 = res.data.records
           this.totalCount4= res.data.total
        })
      },
      // 图片放大
         oploadImgPre(type){
                if(type == 1) this.oploadDialogVisible = true
            },
                  oploadImgDel(type,index){
              if(type == 1){
                this.form.photo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
              }else{

              }
            },
         handleAvatarSuccess(res, file) {
        this.form.photo = res.data.url
        
        if(this.form.photo){
        this.uploadBoolean = true
         }
      },
       // 多图预览
       handlePictureCardPreview(file) {
        if(file.imgUrl){
          this.dialogImageUrl = file.imgUrl;
        }else{
          this.dialogImageUrl = file.url
        }
        this.dialogVisible = true;
      },
       // 多图预览
       handlePictureCardPreview1(file) {
        if(file.imgUrl){
          this.dialogImageUrl1 = file.imgUrl;
        }else{
          this.dialogImageUrl1 = file.url
        }
        this.dialogVisible1 = true;
      },
        // 多图预览
       handlePictureCardPreview2(file) {
        if(file.imgUrl){
          this.dialogImageUrl2 = file.imgUrl;
        }else{
          this.dialogImageUrl2 = file.url
        }
        this.dialogVisible2 = true;
      },
          // 多图预览
       handlePictureCardPreview3(file) {
        if(file.imgUrl){
          this.dialogImageUrl3 = file.imgUrl;
        }else{
          this.dialogImageUrl3 = file.url
        }
        this.dialogVisible3 = true;
      },
             // 多图预览
       handlePictureCardPreview4(file) {
        if(file.imgUrl){
          this.dialogImageUrl4 = file.imgUrl;
        }else{
          this.dialogImageUrl4 = file.url
        }
        this.dialogVisible4 = true;
      },
        // 多图上传
      handleChange(file, fileList){
        this.moreImg = fileList.slice(-2);
      },
        // 多图上传
      handleChange1(file, fileList){
        this.moreImg1 = fileList.slice(-100);
      },
          // 多图上传
      handleChange2(file, fileList){
        this.moreImg2 = fileList.slice(-100);
      },
           // 多图上传
      handleChange3(file, fileList){
        this.moreImg3 = fileList.slice(-100);
      },
            // 多图上传
      handleChange4(file, fileList){
        this.moreImg4 = fileList.slice(-100);
      },
      // 多图移除
      handleRemove1(file, fileList){
      this.moreImg = fileList.slice(-2);
      },
      // 多图移除
      handleRemove3(file, fileList){
      this.moreImg1 = fileList.slice(-100);
      },
       // 多图移除
      handleRemove4(file, fileList){
      this.moreImg2 = fileList.slice(-100);
      },
         // 多图移除
      handleRemove5(file, fileList){
      this.moreImg3 = fileList.slice(-100);
      },
           // 多图移除
      handleRemove6(file, fileList){
      this.moreImg4 = fileList.slice(-100);
      },
        // 文件上传超过最大个数
      maxLenImg(){
       this.$message.error('最多添加身份证正反面')
      },
          // 文件上传超过最大个数
      maxLenImg1(){
       this.$message.error('最多添加100张财务记录图片')
      },
               // 文件上传超过最大个数
      maxLenImg2(){
       this.$message.error('最多添加100张安全资料图片')
      },
                 // 文件上传超过最大个数
      maxLenImg3(){
       this.$message.error('最多添加100张就业信息图片')
      },
                   // 文件上传超过最大个数
      maxLenImg4(){
       this.$message.error('最多添加100张获奖证书图片')
      },
      subUserinfo(){
        this.form.agreement = this.fileList.map(item => item.response.data.url).join(',');

        this.form.idCardInfo = this.moreImg.map(item => item.response.data.url).join(',');
        this.form.resume = this.fileList1.map(item => item.response.data.url).join(',');
        this.form.financial = this.moreImg1.map(item => item.response.data.url).join(',');
        this.form.safety = this.moreImg2.map(item => item.response.data.url).join(',');
        this.form.employ = this.moreImg3.map(item => item.response.data.url).join(',');
        this.form.award = this.moreImg4.map(item => item.response.data.url).join(',');
        let params = {
            id:this.$route.query.id,
            businessId:this.businessInfo.id,
            ...this.form
        }
        saveTrainee(params)
        .then(res =>{
          if(res.code == 0){
             this.$util.Notifi('学员档案编辑成功','success','fa-check')
             this.getthisInfo()
            this.editText = false
          }else{
            this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
          }
        })
      },
       subUserinfo1(){
       this.editText = true
      },
      // 学员协议上传成功
      scSuccess(res, file, fileList){
        this.fileList = fileList
      },
      // 学员移除
      handleRemove(file, fileList){
       this.fileList = fileList
      },
      scSuccess1(res, file, fileList){
        this.fileList1 = fileList
      },
      handleRemove2(file, fileList){
       this.fileList1 = fileList
      },
            // 获取成绩单
        getResulttRanscript(data){
            this.centerDialogVisible1 = true
            this.activeName = '1'
            this.radio = '1'
            this.resultQuestionVOList = []
            this.questionList = []
            resulttRanscript({id:data.id}).then(res => {
                this.testerInfo = res.data
                this.resultQuestionVOList = res.data.resultQuestionVOList
                this.resultLogList = res.data.resultLogList
                this.getQuestionListCom(1)
            })
        },
        // 获取仿真成绩单
        getResulttRanscript1(data){
          this.centerDialogVisible2 = true
            this.activeName1 = '1'
             this.radio1 = '1'
           this.processList = []
            this.stepList = []
            this.questionList1 = []
            rasoResulttRanscript({id:data.id}).then(res => {
                this.testerInfo1 = res.data
                this.resultQuestionVOList1 = res.data.resultQuestionVOList
                this.resultLogList1 = res.data.resultLogList
                let newarr = ['startCondition','endCondition']
                this.processList = res.data.processList
                this.processList.forEach(item =>{ 
                newarr.forEach((t,index) =>{
                let str = item[t]
                    let arr = []
                    str = str.trim().replace(/;$/, '');  
                    arr = str.split(';')
                   item[t] = arr.map(item =>{
                        // 分割字符串为数组，
                        let parts = item.split(',');
                        // 构造对象  
                            return {  
                                cond1: parts[0],  
                                tag: parts[1],  
                                name: parts[2],  
                                tj: parts[3],  
                                tj1: parts[4]  
                            };
                    })
                    })
                })
                this.stepList = res.data.stepList
                this.getQuestionListCom1(1)
            })
        },
                     getQuestionListCom(type){
            this.questionList = []
          if(type == 1){
            for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '1'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 2){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='1' && this.resultQuestionVOList[key].doRight == '0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 3){
             for (let  key in this.resultQuestionVOList) {
           if(this.resultQuestionVOList[key].isAnswer =='0'){
                this.questionList.push(this.resultQuestionVOList[key])
             }
            }
        }else if(type == 4){
                this.questionList = this.resultQuestionVOList
             }else{
                this.questionList = []
             }
        },
             getQuestionListCom1(type){
            this.questionList1 = []
          if(type == 1){
            for (let  key in this.stepList) {
           if(this.stepList[key].stepState != 11){
                this.questionList1.push(this.stepList[key])
             }
            }
        }else if(type == 2){
          console.log(2)
             for (let  key in this.stepList) {
           if(this.stepList[key].stepState == 11){
                this.questionList1.push(this.stepList[key])
             }
            }
        }else if(type == 3){
                this.questionList1 = this.stepList
             }else{
                this.questionList1 = []
             }
        },
                   // 子组件触发
      emitFun(val,val1,type){
        if(val1 == "PageSize") this[`PageSize${type}`] = val
       if(val1 == "currentPage") this[`currentPage${type}`] = val
       if(type == 2 || type == 3){
          this.getlistExamResult1(type)
       }else if(type == 4){
        this.getcertList()
       } else if(type == 5){
        this.getcoureWater()
       } else{
        this.getlistExamResult(type)
       }
      },
        // 显示不同状态
        getStatu(state,type){
             // type = 1 表示考试状态;2、表示考试状态class
              const actionTypelanes = { 
                0:type== 1 ? '答卷中' : type == 2 ? 'tab-yellow' : '',
                1:type== 1 ? '已答完' : type == 2 ? 'tab-blue' : ''
              }
              return actionTypelanes[state] || ''
        },
        // 参与考试试卷列表获取
        getlistExamResult(type){
             // type 0:正式考试、1:练习考试
            let params = {
                businessId:this.$route.query.businessId,
                practiceMode:type,
                accountId:this.$route.query.id,
                size:this[`PageSize${type}`],
                current:this[`currentPage${type}`],
            }
            listExamResult(params)
            .then(res =>{
               this[`itemList${type}`] = res.data.records
               this[`totalCount${type}`] = res.data.total
            })
        },
         // 参与考试试卷列表获取
        getlistExamResult1(type){
             // type :正式考试、2:练习考试
             let practiceMode = type == 2 ? 0 : 1
            let params = {
                businessId:this.$route.query.businessId,
                practiceMode:practiceMode,
                answerAccountId:this.$route.query.id,
                size:this[`PageSize${type}`],
                current:this[`currentPage${type}`],
            }
            rasoListExamResult(params)
            .then(res =>{
               this[`itemList${type}`] = res.data.records
               this[`totalCount${type}`] = res.data.total
            })
        },
        // 时间筛选
           classSelect(type){
           if(this.value2){
             this.starTime = this.value2[0]
            this.endTime = this.value2[1]
            }else{
              this.starTime = ""
              this.endTime = ""
            }
          this.getlistDailyScore(type)
        },
           // 时间筛选
           classSelect1(type){
           if(this.value3){
             this.starTime1 = this.value3[0]
            this.endTime1 = this.value3[1]
            }else{
              this.starTime1 = ""
              this.endTime1 = ""
            }
          this.getlistDailyScore(type)
        },
           // 时间筛选
           classSelect2(type){
           if(this.value4){
             this.starTime2 = this.value4[0]
            this.endTime2 = this.value4[1]
            }else{
              this.starTime2 = ""
              this.endTime2 = ""
            }
          this.getlistDailyScore1(type)
        },
           // 时间筛选
           classSelect3(type){
           if(this.value5){
             this.starTime3 = this.value5[0]
            this.endTime3 = this.value5[1]
            }else{
              this.starTime3 = ""
              this.endTime3 = ""
            }
          this.getlistDailyScore(type)
        },
        // 学员信息
        getthisInfo(){
               let params = {
                businessId:this.$route.query.businessId,
                id:this.$route.query.id,
            }
                getStudentDetail(params,'enterprise')
                .then(res =>{
                  this.list = res.data
                  this.getthisCert()
                  this.form.photo = res.data.photo
                  this.form.studentNum = res.data.studentNum
                  this.form.idNum = res.data.idNum
                  this.agreementArr = res.data.agreement.split(",")
                  this.resumeArr = res.data.resume.split(",")
                  // 遍历将字符串转换为数组
                  let  timekey =["agreement","idCardInfo","resume","financial","safety","employ","award"]
                   timekey.forEach((t,index) => {
                    this.form[t] = this.list[t] ? this.list[t].split(",") : []
                  })
                   // 定义映射关系
                        const fieldMap = {
                          agreement: 'fileList',
                          idCardInfo: 'moreImg',
                          resume: 'fileList1',
                          financial: 'moreImg1',
                          safety: 'moreImg2',
                          employ: 'moreImg3',
                          award: 'moreImg4'
                        };
                      
                        // 定义映射函数
                        const mapArrayToStructure = (arr) => {
                          
                          return (arr || []).map(url => ({
                            url,
                            name:url,
                            response: { data: { url } }
                          }));
                        };
                      // 遍历映射关系并赋值
                          Object.entries(fieldMap).forEach(([sourceField, targetField]) => {
                            this[targetField] = mapArrayToStructure(this.form[sourceField]);
                            
                          });
                    //  for (let  key in timekey) {
                    //     this.moreImg.push({
                    //       url:arr[key],
                    //       response:{
                    //         data:{
                    //           url:arr[key]
                    //         }
                    //       }
                    //     })
                    //   }
                })
        .catch(err =>{})
        },
        // 考生成绩变化趋势
        getlistDailyScore(type){
            // type 0:正式考试、1:练习考试
            let params = {
                businessId:this.$route.query.businessId,
                practiceMode:type,
                accountId:this.$route.query.id,
                starTime:type==0 ? this.starTime : this.starTime1,
                endTime:type==0 ? this.endTime : this.endTime1
            }
            listDailyScore(params)
            .then(res =>{
              if(res.code == 0){
                let xData1 = [],
                    sData1 = []
            for (let key in res.data) {
                xData1.push(res.data[key].time)
                sData1.push({
                name:res.data[key].time,
                value:Number(res.data[key].score),
                 itemStyle: {
                    color:  type == 1 ? '#FF6969' : '#699DFF'
                  }
              })
               }
               this[type == 1 ? 'LineChartOption1' : 'LineChartOption'] = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `考生在${params[0].name}号这一天的成绩为${params[0].value}`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData1
                },
                  yAxis: {
                    type: 'value'
                },
                  color:type == 1 ? ['#ff962a'] : ['#699DFF'],
                 series: [
                    {
                    data: sData1,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
              }
            })
        },
                // 考生成绩变化趋势
        getlistDailyScore1(type){
            // type 0:正式考试、1:练习考试
            let params = {
                businessId:this.$route.query.businessId,
                practiceMode:type,
                accountId:this.$route.query.id,
                starTime:type==0 ? this.starTime2 : this.starTime3,
                endTime:type==0 ? this.endTime2: this.endTime3
            }
            rasoListDailyScore(params)
            .then(res =>{
              if(res.code == 0){
                let xData1 = [],
                    sData1 = []
            for (let key in res.data) {
                xData1.push(res.data[key].time)
                sData1.push({
                name:res.data[key].time,
                value:Number(res.data[key].score),
                 itemStyle: {
                    color:  type == 1 ? '#FF6969' : '#699DFF'
                  }
              })
               }
               this[type == 1 ? 'LineChartOption3' : 'LineChartOption2'] = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `考生在${params[0].name}号这一天的成绩为${params[0].value}`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData1
                },
                  yAxis: {
                    type: 'value'
                },
                  color:type == 1 ? ['#ff962a'] : ['#699DFF'],
                 series: [
                    {
                    data: sData1,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
              }
            })
        },
        // 打开分类知识点
        openy(type,isFz){
            this.centerDialogVisible = true,
            type == 0 ? this.title = '正式考试分类知识点答题正确率' : '练习模式分类知识点答题正确率'
            if(isFz == 'web'){
            this.getCountRate(type,isFz)
            }else{
                this.getCountRate1(type,isFz)
            }
        },
        
        // 分类知识点答题统计
        getCountRate(type,isFz){
            // type 0:正式考试、1:练习考试
            let params = {
                businessId:this.$route.query.businessId,
                practiceMode:type,
                accountId:this.$route.query.id
            }
            countRateQuestionClassifyList(params)
            .then(res =>{
                if(res.code == 0){
                    if(isFz){
                     this.tabletype = type
                     this.tableName = isFz
                    type == 0 ?  this.segmentData = res.data :  this.segmentData1 = res.data
                    }
                 let xData = []
                 let seriesData = []
                  for (let key in res.data) {
              xData.push(res.data[key].classifyName)
              seriesData.push({
                name:res.data[key].classifyName,
                value:Number(res.data[key].rate),
                 itemStyle: {
                    color:  type == 1 ? '#FF6969' : '#699DFF'
                  }
              })
            }
             this[type == 1 ? 'BarChartOption' : 'BarChartOption1'] = {
              title: {
                  text: '分类知识点答题正确率',
                  left: 'center'
                },
               tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                 formatter:function(params){
                    var str = '';
                     str = `${params[0].data.name}</br>正确率：${params[0].data.value}%`
                     return str
                  }
              },
               legend: {
              data: xData
            },
            
              grid: {
                left: '3%', 
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                  {
                    type: 'category',
                    data: xData,
                    axisTick: {
                      alignWithLabel: true
                    }
                  }
                ],
               yAxis: [
                  {
                    type: 'value',
                    position: 'middle',
                    name:'正确率%',
                    min:0,
                    max:100
                  }
                ],
               series: [
                  {
                    
                    type: 'bar',
                    barWidth: '10%',
                    data: seriesData
                  },
                ]
            }
                }
            })
        },
                // 仿真分类知识点答题统计
        getCountRate1(type,isFz){
            // type 0:正式考试、1:练习考试
            let params = {
                businessId:this.$route.query.businessId,
                practiceMode:type,
                accountId:this.$route.query.id
            }
            rasoCountResultRateByApp(params)
            .then(res =>{
                if(res.code == 0){
                 if(isFz){
                     this.tabletype = type
                      this.tableName = isFz
                    type == 0 ?  this.segmentData = res.data :  this.segmentData1 = res.data
                    }
                 let xData = []
                 let seriesData = []
                  for (let key in res.data) {
              xData.push(res.data[key].appName)
              seriesData.push({
                name:res.data[key].appName,
                value:Number(res.data[key].rate),
                 itemStyle: {
                    color:  type == 1 ? '#FF6969' : '#699DFF'
                  }
              })
            }
             this[type == 1 ? 'BarChartOption2' : 'BarChartOption3'] = {
              title: {
                  text: '分类知识点答题正确率',
                  left: 'center'
                },
               tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                 formatter:function(params){
                    var str = '';
                     str = `${params[0].data.name}</br>正确率：${params[0].data.value}%`
                     return str
                  }
              },
               legend: {
              data: xData
            },
            
              grid: {
                left: '3%', 
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                  {
                    type: 'category',
                    data: xData,
                    axisTick: {
                      alignWithLabel: true
                    }
                  }
                ],
               yAxis: [
                  {
                    type: 'value',
                    position: 'middle',
                    name:'正确率%',
                    min:0,
                    max:100
                  }
                ],
               series: [
                  {
                    
                    type: 'bar',
                    barWidth: '10%',
                    data: seriesData
                  },
                ]
            }
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.exams-item:hover{
    border: 1px solid #36aafd;
}
.exams-item{
    width: auto !important;
    margin-bottom: 16px;
    padding: 16px 24px;
    border-radius: 3px;
    border: solid 1px #e6e6e6;
    position: relative;
    .exams-item-info{
        position: relative;
        margin: 10px 0;
        .courseimg{
            width: 300px !important;
            height: 210px !important;
        }
        .exams-item-info-rule{
            flex-direction: column;
            height: 200px;
            flex: 1;
            padding: 0 15px;
            color: #999;
            width: calc(100% - 300px);
            position: relative;
        }
        .dateTit{
            font-size: 13px;
            font-weight: 400;
            color: #666;
            	display: -webkit-box;  
                -webkit-line-clamp: 2;  
                -webkit-box-orient: vertical;  
                overflow: hidden;  
                text-overflow: ellipsis;
        }
        .dateTit1{
            align-items: flex-end;
             font-weight: 400;
             color: rgb(180, 183, 193);
             font-size: 13px;
        }
        .gqimg{
           width: 300px;

           position: absolute;
           right: 100px;
        }
        .coursebtn{
            display: block;
            background-image: linear-gradient(60deg, #36c0fd 0%, #3672fd 100%) !important;
                color: #fff;
                height: 36px;
                padding: 0px 18px;
                border-radius: 4px !important;
                text-decoration: none !important;
                white-space: nowrap;
                cursor: pointer;
                border: 1px solid #e4e4e4;
                box-sizing: border-box;
                line-height: 36px;
                margin-right: 20px;
                width: 120px;
                text-align: center;
                margin: -20px 0 0 0;
        }
        .coursebtn1{
            display: block;
            width: 120px;
                 height: 36px;
                 line-height: 36px;
                padding: 0px 18px;
                margin: 20px 0 0 0;
                                margin-right: 20px;
                border: 1px solid rgba(1, 87, 255, 0.2);
                border-radius: 4px;
                box-sizing: border-box;
                color: #0157ff;
                cursor: pointer;
                transition: background-color 0.3s linear 0s, border-color 0.3s linear 0s;
                text-align: center;
        }
    }
}
   .editUserInfo-form{
         margin-bottom: 44px;
           .sdc-h-down-msg{
        margin-top: 20px;
        .sdc-h-down-msg-list{
            display: flex;
            flex-wrap: wrap;
             .w-100{
              width: 100% !important;
             }
            .w-25{
                width: 50%;
                span{
                  padding-left: 12px;
                    color: #999;  
                }
                div{
                   margin: 8px 20px 0 12px;
                    font-size: 20px;
                    background-color: #fafafa;
                    color: #333;
                    padding: 7px 12px;
                }
                 .img-card{
                  position: relative;
                flex-wrap: wrap;
                     img{
                      width: 150px;
                      height: 150px;
                      margin-right: 10px;
                      cursor: pointer;
                      margin-bottom: 20px;
                     }
                    }
            }
        }
    }
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
        .avatar{
          width: 100%;
          height: 100%;
        }
        .upload-icon{
          position: absolute;
    top:10%;
    margin-left: -18px;
    margin-top: -18px;
    left: 50%;
    i{
      color: #000;
      font-size: 12px;
    }
        }
         }
     .public-btn{
    min-width: 60px;
    cursor: pointer;
    color: #409eff;
    padding: 7px 10px;
    border-radius: 4px !important;
    text-align: center;
    border: none;
    background: #409eff;
    color: #fff;
        }
.print-tab-content{
    margin-top: 20px;
    .tester-info{
        text-align: center;
        .text{
            margin-bottom: 0px;
            font-size: 20px;
            color: #333;
        }
        .lastP{
            font-size: 14px;
            color: #999;
        }
        .sorceRow{
            margin: 20px  0 10px 0;
            .exam-record-info{
                flex-grow: 1;
                .score-num{
                   color: #333;
                   font-size: 50px;
                   position: relative;
                   font-weight: bold;
                   span{
                    font-size: 14px;
                    
                   }
                //    .UserNum{
                //     position: absolute;
                //     top: 0; 
                //     right: 0;
                //     .pbot{
                //         font-size: 14px;
                //     }
                //    }
                }
            }
        }
    }
}
.watermark{
    .question{
        margin-top: 50px;
        .question-main-content{
            .row{
                .ques-title{
                    vertical-align: middle;
                    -webkit-margin-before: 0;
                    -webkit-margin-after: 0;
                    word-break: break-word; 
                   .ques-number,.ques-type{
                    color: #36aafd;
                   } 
                   .ques-score{
                    color: #aeaeae;
                   }
                }
                .ques-answers{
                    margin-top: 15px;
                    .test_result{
                        justify-content: space-between;
                        .userAnswer{
                            margin-bottom: 20px;
                            color: #666;
                            .test_result_span_title{
                                color: #333;

                            }
                            .true{
                                color: green;

                            }
                            .false{
                                color: red;
                            }
                        }
                        .dnl{
                            span{
                               color: #36aafd
                            }
                        }
                    }
                }
                .jx{
                    color: #999;
                        padding-top: 10px;
                        font-size: 16px;
                }
            }
        }
    }
}
.tab-blue{
    color: #699DFF;
    font-weight: bold;
}
.tab-yellow{
    color: #FF6969;
    font-weight: bold;
}
.tagbq{
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
    display: inline-block;
    height: 32px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    color: #409eff;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    margin-right: 10px;
}
.studentDetail{
    margin-bottom: 70px;
    
}
.sdc-head{
    background-color: #fff;
    border-radius: 8px;  
    margin-top: 10px;
    .sdc-h-up{
    background-color: #fafafa;
    padding: 16px;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid #e6e6e6;
    img{
        width: 80px;
    height: 80px;
    object-fit: contain;
    margin-right: 24px;
    }
      .left-info{
            .name{
                padding-bottom: 10px;
                color: #333;
            }
            .name{
                font-size: 16px;
                font-weight: 500;
            }
            .logintime{
                color: #999;
                font-size: 14px;
                font-weight: bold;
            }
        }
    }
    .sdc-h-down{
        padding: 16px;
        .sdc-h-down-data{
            display: flex;
            flex-wrap: wrap;
            div{
                width: 30%;
                margin-bottom: 24px;
                .span1{
                    color: #999;
                }
                .span2{
                        margin-left: 20px;
                }
            }
        }
    .sdc-h-down-msg{
        margin-top: 20px;
        .sdc-h-down-msg-list{
            display: flex;
            flex-wrap: wrap;
            .w-25{
                width: 25%;
                span{
                  padding-left: 12px;
                    color: #999;  
                }
                div{
                   margin: 8px 20px 0 12px;
                    font-size: 20px;
                    background-color: #fafafa;
                    color: #333;
                    padding: 7px 12px;
                    font-weight: 700; 
                }
            }
        }
    }
    }
}
.rdsdiv{
        height: 20px;
    background: #f7f8fa;
    width: calc(100% + 32px);
    margin-left: -16px;
}
.paper-content{
    position: relative;
    padding-bottom: 20px;
    .student-detailds-chart{
     background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    flex: 0 0 50%;
    max-width: 50%;
    .student-detailds-chart-head{
        padding: 9px 16px;
        border-bottom: 1px solid #e6e6e6;
        span{
            font-weight: 700;
            font-size: 18px;
            color: #333;
        }
       .yks-blue{
            background-color: #36aafd;
            color: white;
            border: 1px solid #36aafd;
            padding: 7px 20px;
            border-radius: 4px!important;
            margin-left: auto;
            cursor: pointer;
       } 
    }
       .summaryOfTestPie{
          margin-top: 36px;
          .exam-pr-pie{
            height: 400px;
            padding: 20px;
            border: 1px solid #e6e6e6;
            border-radius: 10px;
          }
        }
    }
}
::v-deep{
    .el-date-editor--datetimerange.el-input__inner {
        width: 250px !important;
    }
}
</style>